<!-- eslint-disable prettier/prettier -->
<template>
  <div v-if="errorDialogParameter.isErrorDialog">
    <div class="k-dialog-wrapper" tabindex="0">
      <div class="k-widget k-window k-dialog" role="dialog">
        <div class="k-window-titlebar k-dialog-titlebar">
			    <div class="k-window-title k-dialog-title">
            <div v-html="errorDialogParameter.title"></div>
          </div>
			      <div class="k-window-actions k-dialog-actions">
				      <button class="k-button k-button-md k-rounded-md k-icon-button k-button-flat k-button-flat-base k-window-action k-dialog-action" aria-label="Close" type="button"  @click.prevent="applyOk()">
					      <span role="presentation" class="k-icon k-button-icon k-i-x"/>
					      <!---->
				      </button>
			      </div>
		      </div>
          <div class="m-container">
            <div v-html="errorDialogParameter.text" class="m-content"></div>
          </div>

          <div class="k-content k-window-content k-dialog-content">
			      
			      <button class="k-button k-button-md k-rounded-md k-button-solid k-button-solid-light">
				    <!---->
				      <span class="k-button-text" @click.prevent="applyOk()">Schliessen</span>
			      </button>
		      </div>
		      <!---->


        </div>
      </div>
  </div>  
</template>
<script lang="ts">
import { ErrorStateServiceForRoot } from "@/infrastructure/observables/errorState";
import { reactive , defineComponent} from "vue";


export default defineComponent ({
  name: "ErrorPopup",
  emits: {
      closed: () => true
    },
  props: {  
    isErrorDialog: {
      type: Boolean,
       default: null,
      require: true
    },
    endpoint: {
      type: String,
       default: null,
      require: false
    },
    dialogName: {
      type: String,
      default: null,
      require: false
    },
      title: {
      type: String,
      default: null,
      require: false
    },
      text: {
      type: String,
      default: null,
      require: false
    }
  },
  inheritAttrs: false,
  components: {},
  setup( props, {emit}) {

    const errorState = ErrorStateServiceForRoot.getErrorStateService()

    const errorDialogParameter = reactive({
      isErrorDialog: props.isErrorDialog,
      dialogName: props.dialogName,
      title: props.title,
      text: props.text,
      endpoint: props.endpoint
      })
  
    function applyOk() {
      errorDialogParameter.isErrorDialog=false;
      errorState.resetErrorState(); 
      emit("closed");
    }

    function setUserFriendlyText() {      

      if ( (errorDialogParameter.text ?? "").indexOf("Error.Exchange Status => 500") >= 0) errorDialogParameter.text = errorDialogParameter.text = "Der Service ist nicht verfügbar";
      if ( (errorDialogParameter.text ?? "").indexOf("Bad Request") >= 0) errorDialogParameter.text = errorDialogParameter.text = "Der Service meldet einen fehlerhafte Verarbeitung zurück";

      if ( (errorDialogParameter.endpoint ?? "").indexOf("start") >= 0 ) errorDialogParameter.text = "Der Service ist nicht verfügbar";       
      if ( (errorDialogParameter.endpoint ?? "").indexOf("login") >= 0 ) errorDialogParameter.text = "Anmeldung fehlgeschlagen";  

      if ( !errorDialogParameter.title || errorDialogParameter.title.length < 1  ) errorDialogParameter.title = "Fehler";
      if ( !errorDialogParameter.text || errorDialogParameter.text.length < 1  ) errorDialogParameter.text = "Bitte ünerprüfen Sie Ihre Eingabe";

      }

    setUserFriendlyText()

    return {    
      applyOk,
      errorDialogParameter,
    };
  }
});
</script>
<style scoped lang="scss">

.k-dialog-content {
  min-height: 60px!important;
}

.k-widget {
  max-width: 600px!important;
}

.m-container {
  height: 100%;
  display: flex;
  flex-direction: column;
  margin-left: 2vw;
  margin-right: 2wh;
  margin-top: 2vh;
  margin-bottom: 2vh;
  max-height: 66vh;
  overflow-y: auto ;
  //overflow-x: auto ;
  min-width: 50vw;
  max-width: 70vw;
  //text-align: center;
}

.m-content {
  flex: 1;
  text-align: left!important;
}

.app__modal {
  position: fixed;
  margin-left: 20vw;
  margin-top: 10vh;
  height: 30vh;
  width: 60vw;
  border: 1pt, solid, rgb(60, 60, 60);
  border-radius: 12px;
  z-index: 999;
}

.app__modalcontainer {
  height: 100%;
}

.app__modal--error { 
  background-image: linear-gradient(to bottom right, #D7E1EC 0%, #FFFFFF 100%);
}

.app__modalrow--buttons {
  text-align: center;
  align-content: center;
  padding-bottom: 10%;
  
}


.app__modalrow--title {  
  padding-top: 10%;
  text-align: center;
  align-content: center;
  font-size: 1.8 rem;
  font-weight: bold;
  color: rgb(60, 60, 60) !important;
  
}

.app__modalrow--content {
  text-align: center;
  align-content: center;
  font-size: 1rem;
  min-height: 220px;
  color: rgb(60, 60, 60) !important; 
}



.app__primarybutton {
  background-image: linear-gradient(to bottom right, #ff6600 0%, #ff99cc 100%);
  width: 96% !important;
}


.button__adjust { 
  margin-left: 5%;
  min-width: 80%
}

.button__align {
  text-align: center;
}


.m-container {
  height: 100%;
  display: flex;
  flex-direction: column;
  margin-left: 2vw;
  margin-right: 2vw;
  margin-top: 2vh;
  margin-bottom: 2vh;
  max-height: 66vh;
  overflow-y: auto ;
  //overflow-x: auto ;
  min-width: 93vw;
  max-width: 93vw;
  //text-align: center;
}

.m-content {
  flex: 1;
}

.app__modal {
  position: fixed;
  margin-left: 20vw;
  margin-top: 10vh;
  height: 30vh;
  width: 60vw;
  border: 1pt, solid, rgb(60, 60, 60);
  border-radius: 12px;
  z-index: 999;
}

.app__modalcontainer {
  height: 100%;
}

.app__modal--error { 
  background-image: linear-gradient(to bottom right, #D7E1EC 0%, #FFFFFF 100%);
}

.app__modalrow--buttons {
  text-align: center;
  align-content: center;
  padding-bottom: 10%;
  
}


.app__modalrow--title {  
  padding-top: 10%;
  text-align: center;
  align-content: center;
  font-size: 1.8 rem;
  font-weight: bold;
  color: rgb(60, 60, 60) !important;
  
}

.app__modalrow--content {
  text-align: center;
  align-content: center;
  font-size: 1rem;
  min-height: 220px;
  color: rgb(60, 60, 60) !important; 
}



.app__primarybutton {
  background-image: linear-gradient(to bottom right, #ff6600 0%, #ff99cc 100%);
  width: 96% !important;
}


.button__adjust { 
  margin-left: 5%;
  min-width: 80%
}

.button__align {
  text-align: center;
}


.app__error-frame {
  z-index: 1002;
  position: fixed;
  margin-left: 0vw;
  margin-top: 0vh;
  height: 100vh;
  width: 100vw;
}


.k-dialog-wrapper {
    backdrop-filter: blur(20px)  grayscale(10%) ;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    outline: 0;
    position: fixed;
   
    z-index: 10001;
    border-style: solid;
    box-sizing: border-box;
    //border-radius: 6px!important;
    border-width: 1px!important;  
    border-color: #cfcfcf !important;
}

 .sizing__page-landing{
    top: 12vh;
    left: 0vw;
    width: 100vw;
    height: 80vh;
 }

 .sizing__page {
    top: 4vh;
    left: 0vw;
    width: 100vw;
    height: 88vh;
 }

 .k-dialog-wrapper {
    backdrop-filter: blur(20px)  grayscale(10%) ;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    outline: 0;
    position: fixed;
    top: 4vh;
    left: 0vw;
    width: 100vw;
    height: 88vh;
    max-height: 88vh;
    z-index: 10001;
    z-index: 10001;
    border-style: solid;
    box-sizing: border-box;
    border-radius: 4px;
    border-width: 1px!important;  
    border-color: #cfcfcf !important;
   
  }
  

.k-dialog {
    padding: 0;
    position: fixed;
    box-sizing: border-box;
    border-radius: 4px;
}

.k-window {
    background-color: white!important;
    border-color: #3a3a3a!important;
    border-radius: 2px!important;
    border-width: 1px!important;    
    border-radius: 0px;
    padding: 0;
    border-width: 0px;
    border-style: solid;
    box-sizing: border-box;
    outline: 0;
    font-family: inherit;
    font-size: 14px;
    line-height: 1.25;
    display: inline-flex;
    flex-direction: column;
    position: absolute;
      max-width: 96vw;
      border-radius: 4px;
    z-index: 10002!important;
    -webkit-touch-callout: none;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

.k-window-titlebar {
    border-top-left-radius: 0px;
    border-top-right-radius: 0px;
    padding: 12px 16px;
    border-width: 0 0 1px;
    border-style: solid;
    white-space: nowrap;
    display: flex;
    flex-direction: row;
    flex-shrink: 0;
    align-items: center;
}

.k-window-title {
    padding: .5em 0;
    margin: -.5em 0;
    font-size: 16px;
    line-height: 1.25;
    text-overflow: ellipsis;
    overflow: hidden;
    cursor: default;
    flex: 1;
    display: flex;
    flex-flow: row nowrap;
       align-items: center;
       justify-content: center;
}

.k-dialog-titlebar {
    border-color: inherit;
    color: white;
    background-color: #ff6358;
    border-radius: 2px!important;
}

.k-window-title {
    padding: .5em 0;
    margin: -.5em 0;
    font-size: 16px;
    line-height: 1.25;
    text-overflow: ellipsis;
    overflow: hidden;
    cursor: default;
    flex: 1;
    display: flex;
    flex-flow: row nowrap;
}

.k-window-title::before {
    content: "\200b";
}

.k-window-actions {
    margin: -5em 0;
    margin-inline-end: -4px;
    line-height: 1;
    display: flex;
    flex-flow: row nowrap;
    flex-shrink: 0;
    align-items: center;
    vertical-align: top;
    border-style: none!important;
}

.k-window-action {
    flex-shrink: 0;
}

.k-button {
    box-sizing: border-box;
    border-width: 1px;
    border-style: solid;
    color: inherit;
    background: none;
    font-family: inherit;
    text-align: center;
    text-decoration: none;
    white-space: nowrap;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
    vertical-align: middle;
    -webkit-user-select: none;
        -ms-user-select: none;
            user-select: none;
    cursor: pointer;
    outline: none;
    -webkit-appearance: none;
    position: relative;
    transition: color 0.2s ease-in-out;
}

.k-button *,
.k-button *::before,
.k-button *::after {
    box-sizing: border-box;
}

.k-button-sm {
    padding: 2px 8px;
    font-size: 14px;
    line-height: 1.4285714286;
}

.k-button-md {
    padding: 4px 8px;
    font-size: 14px;
    line-height: 1.4285714286;
}

.k-rounded {
    border-radius: 4px;
}

.\!k-rounded {
    border-radius: 4px !important;
}

.k-rounded-0 {
    border-radius: 0;
}

.\!k-rounded-0 {
    border-radius: 0 !important;
}

.k-rounded-sm {
    border-radius: 2px;
}

.\!k-rounded-sm {
    border-radius: 2px !important;
}

.k-rounded-md {
    border-radius: 4px;
}

.\!k-rounded-md {
    border-radius: 4px !important;
}

.k-icon {
    width: 1em;
    height: 1em;
    outline: 0;
    font-size: 16px;
    font-family: "WebComponentsIcons";
    font-style: normal;
    font-variant: normal;
    font-weight: normal;
    line-height: 1;
    speak: none;
    text-transform: none;
    text-decoration: none;
    flex-shrink: 0;
    display: inline-flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: center;
    vertical-align: middle;
    position: relative;
    -moz-osx-font-smoothing: grayscale;
    -webkit-font-smoothing: antialiased;
}

.k-icon:hover, .k-icon:focus {
    text-decoration: none;
}

.k-icon-button {
    gap: 0;
}

.k-icon-button .k-icon {
    display: inline-flex;
}

.k-button-icon {
    color: inherit;
    align-self: center;
    position: relative;
}

.k-button-sm {
    padding: 2px 8px;
    font-size: 14px;
    line-height: 1.4285714286;
}

.k-button-sm.k-icon-button {
    padding: 2px;
}

.k-button-sm.k-icon-button > .k-button-icon {
    min-width: 20.0000000004px;
    min-height: 20.0000000004px;
}

.k-button-md {
    padding: 4px 8px;
    font-size: 14px;
    line-height: 1.4285714286;
}

.k-button-md.k-icon-button {
    padding: 4px;
}

.k-button-md.k-icon-button > .k-button-icon {
    min-width: 20.0000000004px;
    min-height: 20.0000000004px;
}

.k-button-flat {
    border-color: transparent !important;
    color: inherit;
    background: none !important;
    box-shadow: none !important;
}

.k-button-flat::before {
    display: block !important;
}

.k-button-flat::after {
    box-shadow: inset 0 0 0 2px currentColor;
    display: block !important;
}

.k-button-flat:focus::after, .k-button-flat.k-focus::after {
    opacity: .12;
}

.k-button-flat-base {
    color: inherit;
}

.k-content {
    outline: 0;
    text-align: center;
    margin-top: 2vh;
    margin-bottom: 2vh;
}

.k-content {
    border-color: rgba(0, 0, 0, 0.08);
    color: #424242;
    background-color: #ffffff;
}

.k-window-content,
.k-prompt-container {
    padding: 16px 16px;
    border-width: 0;
    border-color: inherit;
    color: inherit;
    background: none;
    outline: 0;
    overflow: auto;
    position: relative;
    flex: 1 1 auto;
}

.k-window-content + .k-prompt-container {
    margin-top: -8px;
}

.k-window-content:first-child {
    padding-top: clamp(16px, 12px, 12px);
}

.k-window-content:last-child {
    padding-bottom: clamp(16px, 12px, 12px);
}

.k-window-iframecontent {
    padding: 0;
    overflow: visible;
}

.k-window-iframecontent .k-content-frame {
    vertical-align: top;
    border: 0;
    width: 100%;
    height: 100%;
}

.k-button-solid-base {
    border-color: rgba(0, 0, 0, 0.08);
    color: #424242;
    background-color: #f5f5f5;
    background-image: linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.02));
}

.k-button-solid-base:hover, .k-button-solid-base.k-hover {
    background-color: #ebebeb;
}

.k-button-solid-base:focus, .k-button-solid-base.k-focus {
    box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.08);
}

.k-button-solid-base:active, .k-button-solid-base.k-active {
    background-color: #d8d8d8;
}

.k-button-solid-base.k-selected {
    border-color: #ff6358;
    color: white;
    background-color: #ff6358;
}

.k-button-solid-primary {
    border-color: #ff6358;
    color: white;
    background-color: #ff6358;
    background-image: linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.02));
}

.k-button-solid-primary:hover, .k-button-solid-primary.k-hover {
    border-color: #f55f54;
    background-color: #f55f54;
}

.k-button-solid-primary:focus, .k-button-solid-primary.k-focus {
    box-shadow: 0 0 0px 2px rgba(255, 99, 88, 0.3);
}

.k-button-solid-primary:active, .k-button-solid-primary.k-active {
    border-color: #e0574d;
    background-color: #e0574d;
}

.k-button-solid-primary.k-selected {
    border-color: #e0574d;
    background-color: #e0574d;
}

.k-button-solid-secondary {
    border-color: #666666;
    color: white;
    background-color: #666666;
    background-image: linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.02));
}

.k-button-solid-secondary:hover, .k-button-solid-secondary.k-hover {
    border-color: #626262;
    background-color: #626262;
}

.k-button-solid-secondary:focus, .k-button-solid-secondary.k-focus {
    box-shadow: 0 0 0px 2px rgba(102, 102, 102, 0.3);
}

.k-button-solid-secondary:active, .k-button-solid-secondary.k-active {
    border-color: #5a5a5a;
    background-color: #5a5a5a;
}

.k-button-solid-secondary.k-selected {
    border-color: #5a5a5a;
    background-color: #5a5a5a;
}

.k-button-solid-tertiary {
    border-color: #03a9f4;
    color: white;
    background-color: #03a9f4;
    background-image: linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.02));
}

.k-button-solid-tertiary:hover, .k-button-solid-tertiary.k-hover {
    border-color: #03a2ea;
    background-color: #03a2ea;
}

.k-button-solid-tertiary:focus, .k-button-solid-tertiary.k-focus {
    box-shadow: 0 0 0px 2px rgba(3, 169, 244, 0.3);
}

.k-button-solid-tertiary:active, .k-button-solid-tertiary.k-active {
    border-color: #0395d7;
    background-color: #0395d7;
}

.k-button-solid-tertiary.k-selected {
    border-color: #0395d7;
    background-color: #0395d7;
}

.k-button-solid-info {
    border-color: #0058e9;
    color: white;
    background-color: #0058e9;
    background-image: linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.02));
}

.k-button-solid-info:hover, .k-button-solid-info.k-hover {
    border-color: #0054e0;
    background-color: #0054e0;
}

.k-button-solid-info:focus, .k-button-solid-info.k-focus {
    box-shadow: 0 0 0px 2px rgba(0, 88, 233, 0.3);
}

.k-button-solid-info:active, .k-button-solid-info.k-active {
    border-color: #004dcd;
    background-color: #004dcd;
}

.k-button-solid-info.k-selected {
    border-color: #004dcd;
    background-color: #004dcd;
}

.k-button-solid-success {
    border-color: #37b400;
    color: white;
    background-color: #37b400;
    background-image: linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.02));
}

.k-button-solid-success:hover, .k-button-solid-success.k-hover {
    border-color: #35ad00;
    background-color: #35ad00;
}

.k-button-solid-success:focus, .k-button-solid-success.k-focus {
    box-shadow: 0 0 0px 2px rgba(55, 180, 0, 0.3);
}

.k-button-solid-success:active, .k-button-solid-success.k-active {
    border-color: #309e00;
    background-color: #309e00;
}

.k-button-solid-success.k-selected {
    border-color: #309e00;
    background-color: #309e00;
}

.k-button-solid-warning {
    border-color: #ffc000;
    color: black;
    background-color: #ffc000;
    background-image: linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.02));
}

.k-button-solid-warning:hover, .k-button-solid-warning.k-hover {
    border-color: #f5b800;
    background-color: #f5b800;
}

.k-button-solid-warning:focus, .k-button-solid-warning.k-focus {
    box-shadow: 0 0 0px 2px rgba(255, 192, 0, 0.3);
}

.k-button-solid-warning:active, .k-button-solid-warning.k-active {
    border-color: #e0a900;
    background-color: #e0a900;
}

.k-button-solid-warning.k-selected {
    border-color: #e0a900;
    background-color: #e0a900;
}

.k-button-solid-error {
    border-color: #f31700;
    color: white;
    background-color: #f31700;
    background-image: linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.02));
}

.k-button-solid-error:hover, .k-button-solid-error.k-hover {
    border-color: #e91600;
    background-color: #e91600;
}

.k-button-solid-error:focus, .k-button-solid-error.k-focus {
    box-shadow: 0 0 0px 2px rgba(243, 23, 0, 0.3);
}

.k-button-solid-error:active, .k-button-solid-error.k-active {
    border-color: #d61400;
    background-color: #d61400;
}

.k-button-solid-error.k-selected {
    border-color: #d61400;
    background-color: #d61400;
}

.k-button-solid-dark {
    border-color: #424242;
    color: white;
    background-color: #424242;
    background-image: linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.02));
}

.k-button-solid-dark:hover, .k-button-solid-dark.k-hover {
    border-color: #3f3f3f;
    background-color: #3f3f3f;
}

.k-button-solid-dark:focus, .k-button-solid-dark.k-focus {
    box-shadow: 0 0 0px 2px rgba(66, 66, 66, 0.3);
}

.k-button-solid-dark:active, .k-button-solid-dark.k-active {
    border-color: #3a3a3a;
    background-color: #3a3a3a;
}

.k-button-solid-dark.k-selected {
    border-color: #3a3a3a;
    background-color: #3a3a3a;
}

.k-button-solid-light {
    border-color: #ebebeb;
    color: black;
    background-color: #ebebeb;
    background-image: linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.02));
}

.k-button-solid-light:hover, .k-button-solid-light.k-hover {
    border-color: #e2e2e2;
    background-color: #e2e2e2;
}

.k-button-solid-light:focus, .k-button-solid-light.k-focus {
    box-shadow: 0 0 0px 2px rgba(235, 235, 235, 0.3);
}

.k-button-solid-light:active, .k-button-solid-light.k-active {
    border-color: #cfcfcf;
    background-color: #cfcfcf;
}

.k-button-solid-light.k-selected {
    border-color: #cfcfcf;
    background-color: #cfcfcf;
}

.k-button-solid-inverse {
    border-color: #424242;
    color: white;
    background-color: #424242;
    background-image: linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.02));
}

.k-button-solid-inverse:hover, .k-button-solid-inverse.k-hover {
    border-color: #3f3f3f;
    background-color: #3f3f3f;
}

.k-button-solid-inverse:focus, .k-button-solid-inverse.k-focus {
    box-shadow: 0 0 0px 2px rgba(66, 66, 66, 0.3);
}

.k-button-solid-inverse:active, .k-button-solid-inverse.k-active {
    border-color: #3a3a3a;
    background-color: #3a3a3a;
}

.k-button-solid-inverse.k-selected {
    border-color: #3a3a3a;
    background-color: #3a3a3a;
}


</style>
